import React from 'react';
import '../../../css/Grupo1/G1Landing.css';
import  NutricionistaF from '../../../Component/Grupo5/NutricionistaF';


function Nutricionista(){

return(
      <div  >
        <NutricionistaF/>
      </div>

);


}
export default Nutricionista;